import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Tag: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.667 10a8.333 8.333 0 1016.667 0 8.333 8.333 0 00-16.667 0zm14.7 1.983a6.682 6.682 0 01-4.384 4.384c.585-.73 1.062-1.773 1.372-3.012 1.24-.31 2.282-.787 3.012-1.372zm0-3.966c-.73-.585-1.773-1.062-3.012-1.372-.31-1.239-.787-2.282-1.372-3.012a6.682 6.682 0 014.384 4.384zm-2.694.456c.318.109.615.23.885.366.892.446 1.276.9 1.276 1.161s-.384.715-1.276 1.16c-.27.136-.567.258-.885.367a14.883 14.883 0 000-3.054zm-2.146-2.145a7.073 7.073 0 00-.366-.886c-.445-.891-.9-1.275-1.16-1.275-.262 0-.716.384-1.162 1.275a7.07 7.07 0 00-.365.886 14.863 14.863 0 013.053 0zM8.06 8.06A12.941 12.941 0 0110 7.917c.673 0 1.326.05 1.94.143.094.615.144 1.268.144 1.94 0 .672-.05 1.325-.144 1.94-.614.093-1.267.143-1.94.143-.672 0-1.325-.05-1.94-.143A12.939 12.939 0 017.917 10c0-.672.05-1.325.143-1.94zM6.645 6.645c-1.238.31-2.282.787-3.011 1.372a6.682 6.682 0 014.383-4.384c-.584.73-1.061 1.773-1.372 3.012zm-3.011 5.338c.73.585 1.773 1.061 3.011 1.372.31 1.239.788 2.282 1.372 3.012a6.682 6.682 0 01-4.383-4.384zm2.694-.456a7.058 7.058 0 01-.886-.366c-.89-.446-1.275-.9-1.275-1.161s.384-.715 1.275-1.16c.27-.136.567-.258.886-.367a14.863 14.863 0 000 3.054zm2.146 2.145c.108.319.23.616.365.886.446.891.9 1.275 1.161 1.275s.716-.384 1.161-1.275c.135-.27.258-.567.366-.886a14.853 14.853 0 01-3.053 0z"
        fill={color}
      />
    </svg>
  );
};

export default Tag;
